// extracted by mini-css-extract-plugin
export var heroImage = "_jr-1";
export var modal = "_jr-0";